import { WithApolloClient, withApollo } from 'react-apollo'
import { RouteComponentProps, withRouter } from 'react-router-dom'

import { DocumentNode } from 'graphql'
import { Future } from 'monapt'
import { compose, lifecycle } from 'recompose'

export type Queries = {
  query: string | DocumentNode
  variables?: object
}

const defaultOptions = {
  wait: 0,
}

export const prefetchQueries = <T = {}>(
  queries: Queries[],
  options: { wait?: number } = defaultOptions,
  paths: string[] | null = null,
  condition: (props: T) => boolean = (_: T) => true,
) =>
  compose(
    withApollo,

    withRouter,

    lifecycle<T & RouteComponentProps<{}> & WithApolloClient<{}>, {}>({
      componentDidMount() {
        if (!condition(this.props)) {
          return
        }

        const { client, location } = this.props as RouteComponentProps<{}> &
          WithApolloClient<{}>

        if (paths !== null && !paths.includes(location.pathname)) {
          return
        }

        setTimeout(() => {
          queries.forEach(({ query, variables = {} }: any) => {
            Future.create<any>(client.query({ query, variables })).recover(
              () => {
                /* NO-OP */
              },
            )
          })
        }, options.wait)
      },
    }),
  )
